import { ItemCategoryModel } from "../models/ItemCategoryModel";
import { INewItem, ItemImage, ItemModel } from "../models/ItemModel";
import apiService from "./apiService";

const itemService = {

    /**
     * @param categoryId 
     * @param keyword 
     * @param offset -> the number of items to skip 
     * @param count -> the number of items to return
     * @returns 
     */
    searchItems: async (categoryId: number, keyword: string, offset: number, count: number) => {
        const response: { items: any[], itemCount: number } = await apiService.get(`/item?categoryId=${categoryId}&keyword=${keyword}&offset=${offset}&count=${count}`);
        response.items = response.items.map((x) => new ItemModel(x));
        return response;
    },
    getItem: async (itemId: number) => {
        const item = await apiService.get(`/Item/${itemId}`);
        if (!item) {
            throw new Error("Item not found");
        }
        return new ItemModel(item);
    },
    /**
     * 
     * @param item 
     * @returns Could return "Limit" to indicate the seller reaches the total number of items (currently 1000), otherwise return "Success" or "Error".
     */
    createItem: async (item: ItemModel) => {
        const response = await apiService.post("/Item", <INewItem>{ categoryID: item.categoryId, itemName: item.itemName, price: item.price, description: item.description });
        return {result:response.result, item: new ItemModel(response.item)};
    },
    updateItem: async (item: ItemModel) => {
        return await apiService.put(`/Item/${item.itemId}`,
            <INewItem>{
                categoryID: item.categoryId,
                itemName: item.itemName,
                keywords: item.keywords,
                price: item.price,
                description: item.description,
                minOfferQty: item.minOfferQty,
                bulkDiscountEnabled: item.bulkDiscountEnabled,
                bulkMinQty: item.bulkMinQty,
                bulkDiscount: item.bulkDiscount,
                infoLinkTitle: item.infoLinkTitle,
                infoLinkUrl: item.infoLinkUrl,
                infoLinkText: item.infoLinkText,
                availableRegion: item.availableRegion
            });
    },
    updateItemListed: async (itemId: number, listed: boolean) => {
        return await apiService.put(`/Item/${itemId}/Listed`, { listed: listed });
    },
    updateItemFeatured: async (itemId: number, featured: boolean) => {
        return await apiService.put(`/Item/${itemId}/Featured`, { featured: featured });
    },
    updateItemPrimaryImage: async (itemId: number, primaryImage: string) => {
        return await apiService.put(`/Item/${itemId}/PrimaryImage?primaryImg=${encodeURIComponent(primaryImage)}`, {});
    },
    updateItemImageSortOrders: async (itemId:number, images: ItemImage[]) => {
        return await apiService.put(`/Item/${itemId}/ImageSortOrders`, images.map(i => ({ fileName: i.fileName, sortOrder: i.sortOrder })));
    },
    updateItemReturnPolicy: async (itemId: number, useStoreReturnPolicy: boolean, useItemReturnPolicy: boolean, itemReturnPolicy: string) => {
        return await apiService.put(`/Item/${itemId}/ReturnPolicy`, { useStoreReturnPolicy, useItemReturnPolicy, itemReturnPolicy });
    },
    updateItemShippingPolicy: async (itemId: number, useStoreShippingPolicy: boolean, useItemShippingPolicy: boolean, itemShippingPolicy: string) => {
        return await apiService.put(`/Item/${itemId}/ShippingPolicy`, { useStoreShippingPolicy, useItemShippingPolicy, itemShippingPolicy });
    },
    deleteItem: async (itemId: number) => {
        return await apiService.delete(`/Item/${itemId}`);
    },
    getRootItemCategories: async () => {
        const categories = await apiService.get(`/ItemCategory/0`);
        return (categories as any[]).map((x) => new ItemCategoryModel(x));;
    },
    getSubItemCategories: async (parentId: number) => {
        const categories = await apiService.get(`/ItemCategory/${parentId}`);
        return (categories as any[]).map((x) => new ItemCategoryModel(x));
    },
    getAllCategories: async () => {
        const categories = await apiService.get(`/ItemCategory`);
        return (categories as any[]).map((x) => new ItemCategoryModel(x));
    },
    sellerHasItemListing: async (): Promise<boolean> => {
        return await apiService.get(`/Item/Count`) >0;
    }



}

export default itemService;